import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const Barcode = () => {
    // Componente simples para renderizar um código de barras falso
    const bars = Array.from({ length: 50 }, (_, i) => (
        <Box
            key={i}
            sx={{
                width: `${Math.random() * 3 + 1}px`,
                height: '60px',
                backgroundColor: 'black',
                margin: '0 1px'
            }}
        />
    ));

    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mt: 2, p:1, background: 'white', border: '1px solid #eee' }}>
            {bars}
        </Box>
    );
};

const ValeExperiencia = () => {
    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
            background: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)'
        }}>
            <Paper elevation={6} sx={{
                p: { xs: 3, sm: 5 },
                borderRadius: 4,
                textAlign: 'center',
                maxWidth: 600,
                width: '100%',
                border: '2px dashed #8e24aa',
                background: 'rgba(255, 255, 255, 0.95)',
            }}>
                <Typography variant="h4" component="h1" sx={{ color: '#6a1b9a', fontWeight: 'bold', mb: 1 }}>
                    Vale Experiência
                </Typography>
                <Typography variant="h6" sx={{ color: '#8e24aa', mb: 3 }}>
                    Exclusivo para a bunny mais linda desse mundo
                </Typography>
                
                <Box sx={{
                    borderTop: '1px solid #ce93d8',
                    borderBottom: '1px solid #ce93d8',
                    py: 3,
                    my: 3
                }}>
                    <Typography variant="body1" component="p" sx={{ fontStyle: 'italic', color: '#4a148c' }}>
                        "O vale experiência deve ser agendado com 7 dias de antecedência. As informações são surpresas e vale para um domingo dia todo. Apresente esse vale para surtir efeito."
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <Barcode />
                    <Typography variant="caption" sx={{ mt: 1, letterSpacing: '2px', fontFamily: 'monospace' }}>
                        12062024-STELL-WELL-LOVE
                    </Typography>
                </Box>
            </Paper>
            <Button
                component={Link}
                to="/diadamulher"
                variant="contained"
                sx={{
                    mt: 4,
                    background: 'linear-gradient(45deg, #8e24aa, #ab47bc)',
                    color: 'white',
                    borderRadius: '24px',
                    padding: '10px 30px',
                    fontWeight: 'bold',
                }}
            >
                Voltar
            </Button>
        </Box>
    );
};

export default ValeExperiencia;